import { Component, Input } from '@angular/core';

@Component({
    selector: 'cut-footer-bar',
    template: require('./footer.html'),
    styles: [require('./footer.scss')]
})
export class FooterComponent {

  @Input()
  public email: string;

  @Input()
  public isSolicitor: boolean;

  @Input()
  public phone: string;

  @Input()
  public workhours: string;

}
